import BranchesScreen from "@/UI/screens/BranchesScreen";

export default function BranchesRoute() {
    return <BranchesScreen />;
}
